import React, { useState } from "react";
import { default as JoinGroupOrderWebLayout } from "./layout.web";
import { default as JoinGroupOrderMobileLayout } from "./layout.mobile";
import { getImageAsset } from "../../Helpers/get-assets";
import {
    formatDateToHours,
    formatDateToDayAndHours,
    formatTimeslotEntryFromCart,
} from "~/assets/js/Helpers/timeslot-utils";
import useViewport from "../../Helpers/hooks/useViewport";
import useGroupOrder, { MEMBER_BUFFER } from "~/assets/js/global/useGroupOrder";
import { fetchStoreData } from "~/assets/js/Api/storeApi";
import FullPageLoader from "../Loaders/FullPageLoader";
import PropTypes from "prop-types";
import { subsFromDate, isToday } from "~/assets/js/Helpers/date-utils";

export default function JoinGroupOrder({ closeOverlay }) {
    const { joinGroupOrder, groupCartData, loading } = useGroupOrder();
    const heroImageSrc = getImageAsset("group-order-hero.png");
    const [name, setName] = useState("");
    const { isDesktop } = useViewport();
    const { storePickupAddress, isLoading: storeLoading } = fetchStoreData(
        groupCartData?.store_id
    );

    const [redirecting, setRedirecting] = useState(false);

    if (!groupCartData || storeLoading || redirecting) {
        return <FullPageLoader />;
    }

    const {
        owner_name: ownerName,
        shipping_address: shippingAddress,
        shipping_city: shippingCity,
        group_uid: groupOrderId,
        slot_begin: slotBegin,
        slot_end: slotEnd,
        shipping_postcode: shippingPostCode,
        dispatch_type: dispatchType,
        slot_valid_until: slotValid,
    } = groupCartData || {};

    const formatedDate = formatTimeslotEntryFromCart(slotBegin, slotEnd);

    const location = (() => {
        if (dispatchType === "pickup") {
            return storePickupAddress || "";
        }

        return `${shippingAddress}, ${shippingPostCode} ${shippingCity}`;
    })();

    const formatDateToValidUntil = isToday(slotEnd)
        ? formatDateToHours
        : formatDateToDayAndHours;

    const layout = {
        ownerName,
        location,
        groupOrderId,
        formatedDate,
        dispatchType,
        heroImageSrc,
        name,
        slotValidTill: formatDateToValidUntil(
            subsFromDate({ date: slotValid, ...MEMBER_BUFFER })
        ),
        onJoinGroup: async (userInput) => {
            const { ok } = await joinGroupOrder({ participantName: userInput });
            if (ok) {
                closeOverlay();
            }
        },
        onBackClick: () => {
            setRedirecting(true);
            window.location.href = "/warenkorb/";
        },
        setName: (e) => setName(e.target.value),
        loading,
    };

    return (
        <div className="join-group-order">
            {isDesktop ? (
                <div className="join-group-order__overlay--desktop">
                    <JoinGroupOrderWebLayout {...layout} />
                </div>
            ) : (
                <div className="join-group-order__overlay--desktop">
                    <JoinGroupOrderMobileLayout {...layout} />
                </div>
            )}
        </div>
    );
}

JoinGroupOrder.propTypes = {
    closeOverlay: PropTypes.func,
};
